import React from 'react';
import { Grid } from 'semantic-ui-react';
import Helmet from 'react-helmet';
import { PageLayout, CardNavigation, ImageBanner, About, ImageCollection, Contact, Reviews,  } from '@fishrmn/fishrmn-components';

import Layout from '../components/Layout';
import pizza1 from '../static/pizza_1.jpg';
import pizza2 from '../static/pizza_2.jpg';
import pizza3 from '../static/pizza_3.jpg';
import pizza4 from '../static/pizza_4.jpg';
import pizza5 from '../static/pizza_5.jpg';
import pizza6 from '../static/pizza_6.jpg';
import pizza7 from '../static/pizza_7.jpg';

export default class extends React.PureComponent {
  render() {
    return (
      <Layout>
        <Helmet>
          <title>Rossi&#x27;s Pizza Owego | Home</title>
          <meta name="description" content="Home Page for Rossi's Pizza Owego" />
        </Helmet>
        <PageLayout
          banner={ 
              <ImageBanner
                as={ "banner" }
                backgroundImage={ pizza5 }
                backgroundSize={ "cover" }
                height={ 500 }
                header={ <h1 className="page-content-header ">Rossi's Pizza</h1> }
                overlay={ "primary" }
                parallax={ false }
              />
           }
          subfooter={ 
              <CardNavigation
                itemsPerRow={ 2 }
                items={ [{"background":"","type":"color","content":"See Our Menu","link":"/menu/"},{"background":pizza6,"type":"image","content":"","link":""},{"background":pizza7,"type":"image","content":"","link":""},{"background":"","type":"color","content":"Order Online","link":"https://www.toasttab.com/rossispizzaowego/v2/online-order#!/"}] }
                gutter={ false }
                height={ 300 }
                textAlign={ "center" }
              />
           }
        >
          <Grid
            stackable
            className="component-section-container"
            verticalAlign={ "middle" }
            textAlign={ "center" }
          >
            <Grid.Column width={ 16 }>
              <ImageCollection
                as={ "gallery" }
                bordered={ false }
                carouselOptions={{
                  autoScroll:false,
                  autoScrollTime:1000,
                }}
                centered={ true }
                cutUnevenRows={ true }
                disable={ "arrows" }
                header={ "" }
                images={ [pizza1,pizza2,pizza3,pizza4,"https://lh3.googleusercontent.com/p/AF1QipNpWNiiW0udct002u6fYWHeGgvUu-CdP_OMajaR=s1600-w1600-h1600","https://lh3.googleusercontent.com/p/AF1QipPgjTY_8yZqW2Y6qvf6pyYYiDMXO8pt9_rsxUYL=s1600-w1600-h1600","https://lh3.googleusercontent.com/p/AF1QipNglSifXZuMJJ2QatDDWauMqJSUXueSRgSQ-9Ky=s1600-w1080-h1600","https://lh3.googleusercontent.com/p/AF1QipO5tAuLorAfD5lxG18Ef8lzTATbDZowLRdbqoSV=s1600-w1080-h1600","https://lh3.googleusercontent.com/p/AF1QipMc5iW7ylpql8g15WSbwRwxklD6cbwWjswk9NtA=s1600-w1600-h1600","https://lh3.googleusercontent.com/p/AF1QipOzlg1Qj6WVGVBA60wUzRyBp1cWtch1GIDicddB=s1600-w1600-h1600","https://lh3.googleusercontent.com/p/AF1QipMCNt-Z4Lp0MIHUmfeR0Kt9fZewimsF4dHygjEo=s1600-w1600-h1600"] }
                numberOfRowDisplayItems={ 4 }
              />
            </Grid.Column>
          </Grid>
        </PageLayout>
      </Layout>
    );
  }
}